import Layout from '@/layouts/RouterView'
import { hasServices, featureMenuHiddenCheck } from '@/utils/auth'
import i18n from '@/locales'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

const SuggestsOverview = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Subscription/views/suggestsOverview')
const Alert = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Subscription/views/alert')
const AlertSetting = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Subscription/views/alert-setting')
const SuggestsAlert = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsalert')
const SuggestsRule = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestionrule')
const SuggestsRuleConfig = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsysruleconfig')
const SuggestsReport = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsreport')

function menuPath (path) {
  return '/iam' + path
}

export default {
  index: 81,
  meta: {
    label: () => process.env.VUE_APP_PLATFORM === 'operation' ? i18n.t('bill.text_280') : i18n.t('bill.text_280'),
    icon: 'menu-suggest',
    hidden: () => {
      return !hasServices('suggestion')
    },
  },
  menus: [
    {
      path: '/suggestsyoverview',
      meta: {
        label: i18n.t('bill.text_36'),
        permission: 'suggestsysalerts_list',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsyoverview')) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'SuggestsOverview',
          path: '',
          component: SuggestsOverview,
        },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.text_253'),
      },
      submenus: [
        {
          path: '/suggestsysrule',
          meta: {
            label: i18n.t('meter.suggestion_rule'),
            permission: 'suggestsysrules_list',
            // hidden: () => !store.getters.isAdminMode, // show rule for all views
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysrule')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsRule',
              path: '',
              component: SuggestsRule,
              // props: { title: i18n.t('meter.accuracy_rule_setting') },
            },
          ],
        },
        {
          path: '/suggestsysalert',
          meta: {
            label: i18n.t('meter.accuracy_suggestion_list'),
            permission: 'suggestsysalerts_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysalert')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsAlert',
              path: '',
              component: SuggestsAlert,
              props: { title: i18n.t('meter.accuracy_suggestion_list') },
            },
          ],
        },
        {
          path: '/suggestsysruleconfig',
          meta: {
            label: i18n.t('meter.accuracy_ignore_list'),
            permission: 'suggestsysrules_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysruleconfig')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsRuleConfig',
              path: '',
              component: SuggestsRuleConfig,
              props: { title: i18n.t('meter.accuracy_ignore_list') },
            },
          ],
        },
        {
          path: '/suggestsysreport',
          meta: {
            label: i18n.t('meter.suggest_analysis'),
            permission: 'suggestsysalertsreport_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysreport')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsReport',
              path: '',
              component: SuggestsReport,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('subscription.abnormal_consumption'),
      },
      submenus: [
        {
          path: '/alert',
          meta: {
            label: i18n.t('subscription.alert_list'),
            permission: 'bill_alerts_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.alert')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'Alert',
              path: '',
              component: Alert,
            },
          ],
        },
        {
          path: '/alert-setting',
          meta: {
            label: i18n.t('subscription.alert_setting'),
            permission: 'bill_alert_settings_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.alert_setting')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'AlertSetting',
              path: '',
              component: AlertSetting,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('scope.text_960'),
      },
      submenus: [
        {
          path: menuPath('/suggestsysalert'),
          meta: {
            label: i18n.t('meter.security_suggestion_list'),
            permission: 'suggestsysalerts_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.iam_suggestsysalert')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SecuritySuggestsAlert',
              path: '',
              component: SuggestsAlert,
              props: { title: i18n.t('meter.security_suggestion_list') },
            },
          ],
        },
        {
          path: menuPath('/suggestsysruleconfig'),
          meta: {
            label: i18n.t('meter.security_ignore_list'),
            permission: 'suggestsysruleconfigs_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.iam_suggestsysruleconfig')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SecuritySuggestsRuleConfig',
              path: '',
              component: SuggestsRuleConfig,
              props: { title: i18n.t('meter.security_ignore_list') },
            },
          ],
        },
        {
          path: menuPath('/suggestsysrule'),
          meta: {
            label: i18n.t('meter.security_rule_setting'),
            permission: 'suggestsysrules_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.iam_suggestsysrule')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SecuritySuggestsRule',
              path: '',
              component: SuggestsRule,
              props: { title: i18n.t('meter.security_rule_setting') },
            },
          ],
        },
      ],
    },
  ],
}
